<template>
  <div class="dashboard p-4">
    <!-- end nav -->
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Configure Account
          </h1>
        </div>
      </div>
    </div>
   <div class="mt-5">
    <form class="max-w-lg">
      <div class="relative z-0 w-full mb-5 group">
          <input v-model="name" type="text" name="floating_email" id="floating_email" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " required />
          <label for="floating_email" class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >Name
          </label>
      </div>
      <div class="relative z-0 w-full mb-5 group">
        <label
          for="range_share_data"
          class="block text-sm text-gray-500 dark:text-gray-400"
        >
          Range Share Data
        </label>
        <select
          v-model="range"
          name="range_share_data"
          id="range_share_data"
          class="block py-2.5 px-4 w-full text-sm text-gray-900 bg-gray-100 border border-gray-300 appearance-none rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500 peer dark:bg-gray-800 dark:text-white dark:border-gray-700 dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required
        >
          <option value="" disabled selected class="text-gray-400 dark:text-gray-400">Choose One</option>
          <option value="0" class="text-gray-700 dark:text-gray-300">Not Set</option>
          <option value="1" class="text-gray-700 dark:text-gray-300">Weekly</option>
          <option value="2" class="text-gray-700 dark:text-gray-300">Monthly</option>
        </select>
        <p class="dark:text-gray-200 text-sm mt-2">Email : {{ dataUser.email }}</p>
      </div>
      <div class="min-[640px]:flex sm:grid-cols-1">
        <div>
          <button v-on:click.prevent="openModalEmail=true" type="button" class="m-1 h-auto text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Change Email</button>
        </div>
        <div>
          <button v-on:click.prevent="openModalPass= true" type="button" class="m-1 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Change Password</button>
        </div>
        <div class="grid grid-cols-2 max-sm:gap-2">
          <div>
            <div v-if="isLoading">
              <Vue3Lottie :animationData="loading1" :height="40" :width="97" />
            </div>
            <button v-else v-on:click.prevent="editUserHanler" class="m-1 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
              Submit
            </button>
          </div>
          <button v-on:click.prevent="$router.push('/user')" class="m-1 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Cancel</button>
        </div>
      </div>
    </form>
   </div>
  </div>
  <Modal
  title="Change Email"
  subtitle="Fill form below"
  btnTextSubmit="Submit"
  btnType="button"
  btnText="Add Group"
  :btnShow="false"
  :isOpenEx="openModalEmail"
  :footerShow="true"
  @submit="changeMailHandler"
  @updateOpen="openModalEmail = false"
  >
  <template v-slot:body>
    <div class="space-y-5 pb-5">
      <div v-if="isLoading1">
        <Vue3Lottie :animationData="loading1" :height="200" />
      </div>
      <div v-else class="space-y-3">
        <p>Email</p>
        <input
          type="email"
          placeholder=""
          required
          class="p-2 border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
          v-model="email"
        />
        <p class="text-center m-5 text-red-600 text-lg">{{ textError }}</p>
      </div>
    </div>
  </template>
  </Modal>
  <Modal
  title="Change Password"
  subtitle="Fill form below"
  btnTextSubmit="Submit"
  btnType="button"
  btnText="Add Group"
  :btnShow="false"
  :isOpenEx="openModalPass"
  :footerShow="true"
  @submit="changePasswordHandler"
  @updateOpen="openModalPass = false"
  >
  <template v-slot:body>
    <div class="space-y-5 pb-5">
      <div v-if="isLoading1">
        <Vue3Lottie :animationData="loading1" :height="200" />
      </div>
      <div v-else class="space-y-3">
        <p>Password</p>
        <input
          type="password"
          placeholder=""
          required
          class="p-2 border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
          v-model="password"
        />
        <p>Confirm Password</p>
        <input
          type="password"
          placeholder=""
          required
          class="p-2 border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
          v-model="confirmPassword"
        />
        <p class="text-center m-5 text-red-600 text-lg">{{ textError }}</p>
      </div>
    </div>
  </template>
  </Modal>
</template>

<script>
  // @ is an alias to /src
  import { useCounterStore } from "@/store/counter";
  import { Icon } from "@iconify/vue";
  import { mapActions, mapState } from "pinia";
  import Modal from "@/components/modal.vue";
  import loading1 from "../assets/loading9.json";
  import { Vue3Lottie } from 'vue3-lottie';
  import ModalSendMail from "./components/ModalSendMail.vue";
  export default {
    name: "Dashboard",
    data() {
      return {
        name: '' ,
        range: 0,
        isLoading: false,
        isLoading1: false,
        isLoading2: false,
        loading1,
        openModalEmail: false,
        openModalPass: false,
        textError: '',
        email: '',
        password: '',
        confirmPassword: '',
        textError1: ''
      };
    },
    components: {
      Icon, Vue3Lottie, Modal, ModalSendMail
    },
    methods: {
      ...mapActions(useCounterStore,['getDataUser','editUser','changeMail','changePassword']),
      async changePasswordHandler(){
        if(this.password !== this.confirmPassword){
          this.textError = "Password not same"
        } else {
          const check = await this.changePassword(this.password)
          if(check !== true){
            this.textError = check
          }else{
            this.textError = ''
            this.openModalPass = false
          }
        }
      },
      async changeMailHandler(){
        const check = await this.changeMail(this.email)
        if(check !== true){
          this.textError = check
        }else{
          this.textError = ''
          this.openModalEmail = false
        }
      },
      async editUserHanler(){
        this.isLoading = true
        const check = await this.editUser({name: this.name,range: this.range})
        if(check !== true){
          this.textError1 = check
        }else{
          this.$router.push("/user")
        }
        this.isLoading = false
      },
      async delButtonGroup(){
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        }).then((result) => {
          if (result.isConfirmed) {
          //  this.delGroup(this.dataGroupDetail.id)
          }
        });
      },
    },
    created(){
      this.getDataUser()
    },
    computed: {
      ...mapState(useCounterStore, ['dataUser']),
      
    },
    watch: {
      dataUser : {
        handler() {
          this.name = this.dataUser.name,
          this.range = this.dataUser.range
        },
        immediate: true
      }
    }
  };
</script>
